import React, { FC, useEffect } from 'react'
import { LandingPageProps } from './LandingPage.types'
import './LandingPage.scss'
import { sanitizeHTML } from '../../utils/common-utils'

export const LandingPage: FC<LandingPageProps> = props => {
  const { content } = props
  const { backgroundImageUrl, logoImageUrl, logoAltText, heading, subHeading } = content

  useEffect(() => {
    const annualReportBody = document.querySelector('body') as HTMLElement

    if (annualReportBody) {
      annualReportBody.style.display = 'block'
    }
  }, [])

  return (
    <div className='landing-page-container'>
      <div className='Content'>
        <section>
          <div
            className='landing-page'
            style={{
              backgroundImage: `url(${backgroundImageUrl})`,
            }}>
            <div className='landing-page-content u-flex u-flexCol u-flexAlignItemsCenter'>
              <img src={logoImageUrl} alt={logoAltText} />
              <div className='extend-line'>
                <hr className='u-marginTop4gu u-marginBottom0' />
              </div>
              <div className='subtitle-wrapper u-paddingTop4gu'>
                <h1 className='subtitle u-headline u-textColorWhite u-textSizeMsrp7 u-md-textSizeMsrp6 u-sm-textSizeMsrp4 u-textCenter u-textSecondary'>
                  {heading}
                </h1>
              </div>
              {subHeading ? (
                <div
                  className='landing-page-subheading u-size6of12 u-marginTop12gu'
                  dangerouslySetInnerHTML={{ __html: sanitizeHTML(subHeading) }}></div>
              ) : null}
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}
